class BuilderDescription extends HTMLElement {
  constructor() {
    super();

    this.step = this.getAttribute('data-step') || '';
    this.title = this.getAttribute('data-title') || '';
  }

  connectedCallback() {
    this.onSelected = this.onSelected.bind(this);
    this.onDeselected = this.onDeselected.bind(this);

    document.addEventListener('builder-selected-option:true', this.onSelected);
    document.addEventListener('builder-selected-option:false', this.onDeselected);
  }

  disconnectedCallback() {
    document.removeEventListener('builder-selected-option:true', this.onSelected);
    document.removeEventListener('builder-selected-option:false', this.onDeselected);
  }

  onSelected() {
    const matched = this.addToOptionGroup();
    this.style.display = matched ? 'flex' : 'none';
  }

  onDeselected() {
    this.hideDescription();
  }

  hideDescription() {
    this.style.display = 'none';
  }

  getOptionTitle(element) {
    return element.getAttribute('title')
      || element.querySelector('.option-text')?.textContent?.trim()
      || element.querySelector('p')?.textContent?.trim()
      || element.querySelector('.calc-prop')?.value
      || '';
  }

  addToOptionGroup() {
    const calculatorDrawerHeader = document.querySelector('calculator-drawer .calculator-drawer__heading');
    if (!calculatorDrawerHeader || !this.step || !this.title || calculatorDrawerHeader.textContent.includes('Lining')) return false;

    const elementStep = calculatorDrawerHeader.textContent || '';
    const calculatorSelectedElements = document.querySelectorAll('calculator-drawer .selected-option');

    for (const element of calculatorSelectedElements) {
      const elementTitle = this.getOptionTitle(element);

      if (elementStep.includes(this.step) && elementTitle === this.title) {
        element.closest('.element').parentNode.appendChild(this);
        return true;
      }
    }

    return false;
  }
}

customElements.define('builder-description', BuilderDescription);
